import { render, staticRenderFns } from "./MainVideo.vue?vue&type=template&id=7d062468&scoped=true&"
import script from "./MainVideo.vue?vue&type=script&lang=js&"
export * from "./MainVideo.vue?vue&type=script&lang=js&"
import style0 from "./MainVideo.vue?vue&type=style&index=0&id=7d062468&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d062468",
  null
  
)

export default component.exports